import { Directive, EventEmitter, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';

import { Observable, Subscription } from 'rxjs';

import { Analytics } from './analytics.types';

/**
 * Directive for trapping focus within a region.
 * @deprecated
 */
@Directive({
  selector: '[rtcAnalyticsTrack]',
  host: {
    '(click)': 'onClick()',
  },
  standalone: true,
})
export class TrackDirective implements OnChanges, OnDestroy {
  @Input() public rtcAnalyticsTrack: string | false | undefined;
  @Input() public rtcAnalyticsTrackData: any = {};
  @Input() public rtcAnalyticsTrigger: Observable<any> | EventEmitter<any>;

  private triggerSubscription?: Subscription;

  constructor(private analytics: Analytics) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.rtcAnalyticsTrigger && this.rtcAnalyticsTrigger) {
      if (this.triggerSubscription) this.triggerSubscription.unsubscribe();

      this.triggerSubscription = this.rtcAnalyticsTrigger.subscribe(() => this.track());
    }
  }

  public ngOnDestroy(): void {
    if (this.triggerSubscription) {
      this.triggerSubscription.unsubscribe();
    }
  }

  public onClick(): void {
    if (this.rtcAnalyticsTrigger) return;

    this.track();
  }

  public track(): void {
    if (!this.rtcAnalyticsTrack) return;

    this.analytics.track(this.rtcAnalyticsTrack, this.rtcAnalyticsTrackData);
  }
}
